import React from "react";
import authStore from "../../store/authStore";
import CountDown from "../Common/Button/CountDown";
import {merchantConfirmOTP, merchantRegister} from "../../network/api";
import OTPInput from "../Common/Input/OTPInput";
import './style.css';


const StepInputOTP = ({setStep, forgot}) => {
	const {confirmId, phoneNumber, setConfirmId} = authStore() || {};
	
	const handleResend = async () => {
		const res = await merchantRegister({phoneNumber})
		if (res?.success && res?.data?.data?.confirmId) {
			setConfirmId(res?.data?.data?.confirmId)
		}
	}
	
	const handleSubmitOTP = async (otp) => {
		const data = await merchantConfirmOTP({confirmId, otp});
		if (data?.success) {
			setStep(2)
		}
	}
	
	return (
		<div
			className='w-[320px] md:w-[400px] py-[15px] px-[20px] md:px-[50px] md:py-[15px] text-xs bg-white rounded-2xl z-[1]'>
			<form className='flex flex-col w-full justify-center items-center text-center gap-5' action="">
				<h2 className='text-sm font-bold'>Nhập mã xác thực (OTP)</h2>
				<p
					className='text-xs text-[#9E9E9E]'>{`Mã xác thực được gửi đến số điện thoại ${phoneNumber}. Vui lòng kiểm tra tin nhắn và nhập mã xác thực`}</p>
				<OTPInput handleSubmitOTP={handleSubmitOTP}/>
				<p className='w-[225px]'>
					Mã xác thực có hiệu lực trong 2 phút
				</p>
				<CountDown count={25} onClick={handleResend}/>
			</form>
		</div>
	);
}

export default StepInputOTP;
